<template>
  <!-- No close control and no dismissal by background click: this is the way
       out of a retired app, not a notice to flick away. The only ways past it
       are Continue, or the link that admits you meant to be here. -->
  <div class="modal is-active deprecation-modal">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="box">
        <img
          class="deprecation-logo"
          src="/img/gobo-logo-black.svg"
          alt="Gobo"
        />
        <h1>App Deprecated</h1>
        <p class="deprecation-copy">
          This is the old Gobo organizer web app, which has been deprecated in
          favor of the new, improved experience. Click continue to be taken to
          the new app.
        </p>
        <a class="button is-dark is-fullwidth" :href="destination">
          Continue
        </a>
        <a class="stay-here" @click="$emit('continue-here')">
          Continue using this app
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { newAppUrl } from "@/utils/deprecation";

export default {
  name: "DeprecationModal",
  computed: {
    destination() {
      return newAppUrl();
    }
  }
};
</script>

<style lang="scss" scoped>
.deprecation-modal {
  .modal-content {
    max-width: 480px;
  }
  .box {
    padding: 2.5rem 2rem;
    text-align: center;
  }
  .deprecation-logo {
    height: 28px;
    margin-bottom: 1.5rem;
  }
  h1 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }
  .deprecation-copy {
    margin-bottom: 2rem;
    line-height: 1.5;
  }
  .stay-here {
    display: inline-block;
    margin-top: 1rem;
    font-size: 0.8rem;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
